import classnames from "classnames";
import capitalize from "lodash/capitalize";
import lowerCase from "lodash/lowerCase";
import {FaGaugeHigh} from "react-icons/fa6";

import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";
import {PlanLimitMonitoringGroupLevel} from "@/lib/types/accounts.ts";
import {Plan} from "@/lib/types/billing.ts";
import {MonitoringGroupLevel, MonitoringGroupLevelName, MonitoringGroupLevelRank} from "@/lib/types/monitoring.ts";
import {ResetLocationsAction} from "@/pages/billing/subscription/plan/actions/ResetLocationsAction.tsx";

import css from "./PlanRow.module.css";

export interface PlanRowCheckLocationsProps {
  name: string;
  limits?: PlanLimitMonitoringGroupLevel;
  plan: Plan;
}

export const PlanRowCheckLocations = ({name, limits, plan}: PlanRowCheckLocationsProps) => {
  const overLimit =
    MonitoringGroupLevelRank[limits?.used || MonitoringGroupLevel.LEVEL_0] >
    MonitoringGroupLevelRank[limits?.included || MonitoringGroupLevel.LEVEL_0];
  const overLimitTooltip =
    "The selected plan is unavailable due to locations configured that are not available in this plan. Please update the locations or click the button below to reset all tests to this plan's default locations.";
  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className={classnames(css.PlanRowIndicator, css.PlanRowIndicatorRed)}>
          {overLimit && (
            <TooltipWrapper toolTip={overLimitTooltip}>
              <span>
                <FaGaugeHigh />
              </span>
            </TooltipWrapper>
          )}
        </div>
        <TooltipWrapper toolTip="To see the whole list of available locations please visit our Probe Servers page inside the product UI.">
          <div>
            <h2 className={classnames(css.PlanRowHeader, "w-100 text-center fw-semibold fs-5")}>
              {MonitoringGroupLevelName[limits?.included || MonitoringGroupLevel.LEVEL_0]}
            </h2>
            <div className="w-100 text-center fw-normal">{name}</div>
          </div>
        </TooltipWrapper>
        <div className={classnames(css.PlanRowIndicator, css.PlanRowIndicatorRed)}></div>
      </div>
      {overLimit && (
        <TooltipWrapper toolTip={`Reset all check locations to use ${capitalize(lowerCase(plan))} plan locations`}>
          <div className="mt-2">
            <ResetLocationsAction plan={plan} />
          </div>
        </TooltipWrapper>
      )}
    </div>
  );
};
